import React from 'react';

import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { DataGrid, GridColDef, GridPaginationModel, GridRowParams } from '@mui/x-data-grid';

const defaultColumns: Array<GridColDef> = [
  { field: 'id', headerName: 'ID', width: 400, display: 'flex' },
  {
    field: 'name',
    headerName: 'Name',
    width: 250,
    editable: true,
    display: 'flex',
  },
];

interface Props {
  columns?: Array<GridColDef>;
  loading?: boolean;
  onPaginationModelChange: (model: GridPaginationModel) => void;
  paginationModel: GridPaginationModel;
  rows: Array<App.Business>;
  total: number;
}

export default function BusinessGrid({
  columns = defaultColumns,
  loading,
  onPaginationModelChange,
  paginationModel,
  rows,
  total,
}: Props) {
  function handleRowClick(params: GridRowParams<App.Business>) {
    window.open(`/lebusiness/${params.row.id}/business`, '_blank');
  }

  return (
    <Grid size={12}>
      <Box width="100%" height={600}>
        <DataGrid
          columns={columns}
          loading={loading}
          onPaginationModelChange={onPaginationModelChange}
          onRowClick={handleRowClick}
          paginationMode="server"
          paginationModel={paginationModel}
          rows={rows || []}
          rowCount={total}
        />
      </Box>
    </Grid>
  );
}
